import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validatelandrecordlist',
  templateUrl: './validatelandrecordlist.component.html',
  styleUrls: ['./validatelandrecordlist.component.css']
})
export class ValidatelandrecordlistComponent implements OnInit {
title="Land Record Validation"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/validatelandrecordlist/validatelandrecordlist.component.ts